export default __webpack_public_path__ + "static/media/dsv-ups-eu_it.facb7a85.svg";